import { FooterViewedEvent } from "@brexhq/next/src/telemetry/analyticsEvents";
import { AnalyticsApi } from "@brexhq/next/src/telemetry/types";

export function trackFooterViewIfNeeded(
  path: string | undefined,
  search: string | undefined,
  inView: boolean,
  trackEvent: AnalyticsApi["trackEvent"],
) {
  if (inView && typeof path !== "undefined" && typeof search !== "undefined") {
    const footerEvent = new FooterViewedEvent(path, search);
    trackEvent(footerEvent);
  }
}
